export default __webpack_public_path__ + "static/media/avatarC5.e5140f48.png";